export default function RecentServiceIcon({ name }) {
  const paths = {
    history: <><path d="M4 12a8 8 0 1 0 2-5.3L4 9"/><path d="M4 4v5h5M12 8v5l3 2"/></>,
    service: <path d="M14 6a4 4 0 0 0-5 5L3.5 16.5a2.1 2.1 0 0 0 3 3L12 14a4 4 0 0 0 5-5l-2.5 2.5-2-2Z"/>,
    car: <><path d="m5 16-1-1v-4l2-5h12l2 5v4l-1 1"/><path d="M6 16v2M18 16v2M4 12h16"/></>,
    user: <><circle cx="12" cy="8" r="3.5"/><path d="M5 20c.5-4 3-6 7-6s6.5 2 7 6"/></>,
    speed: <><path d="M4 16a8 8 0 1 1 16 0"/><path d="m12 14 4-4M4 19h16"/></>,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/></>,
    plus: <path d="M12 5v14M5 12h14"/>,
    refresh: <><path d="M20 7v5h-5"/><path d="M4 17v-5h5M18.5 10A7 7 0 0 0 6 7M5.5 14A7 7 0 0 0 18 17"/></>,
    empty: <><path d="M5 4h14v16H5z"/><path d="M8 8h8M8 12h5"/></>,
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{paths[name] || paths.service}</svg>;
}
